<template>
    <div v-if="isLoading" class="loading-overlay"><p>Carregando...</p></div>
    <div v-if="msgAlerta" class="info-alert row-space">{{ msgAlerta }}</div>


    <div v-if="!modoEdicao && !modoEditarGestores && !modoVisualizar">
        <div class="form-edit-page row row-space">
            <SimSelect v-if="showSimSelect" :ckAddTodos="true" v-model:idSelecionado="idSim" />
            <div class="form-item">
                <label class="label-caption" for="nmPesquisa">Pesquisar</label>
                <input type="text" v-model="nmPesquisa" id="nmPesquisa" maxlength="50" v-uppercase />
            </div>
            
            <div class="form-item-char10">
                <label class="label-caption" for="ordenacao">Ordenar por</label>
                <select v-model="ordenacao" id="ordenacao" @change="aplicarOrdenacao">
                    <option value="nome">Nome</option>
                    <option value="nrosim">Nº SIM</option>
                </select>
            </div>

            <button type="button" class="buttom-icon--search" @click="lerDados" />
            <button type="button" class="buttom-icon--add" @click="novoCadastro" />
            <button type="button" class="buttom-icon--close" @click="closeForm" />
        </div>
        

        <div v-if="lsDados.length>0" class="table-wrapper"><table>
            <thead><tr>
                <th>Código</th>
                <th>SIM</th>
                <th>Estabelecimento</th>
                <th v-if="!globalStore.idsim">SIM</th>
                <th>Atividade</th>
                <th>CPF/CNPJ</th>
                <th>Situação</th>
                <th>SISBI</th>
            </tr></thead>
            
            <tbody><tr v-for="(obj, index) in lsDados" :key="obj.id" @click="openView(obj)" 
                :class="{'even-row': index % 2 === 0, 'odd-row': index % 2 !== 0, 'clickabe-row': true}">
                    <td class="col-width-char10 right">{{ obj.cdestabelecimento }}</td>
                    <td class="col-width-char10 right">{{ obj.nrosim }}</td>
                    <td>{{ obj.nmestabelecimento }}</td>
                    <td v-if="!globalStore.idsim" class="col-width-char40">{{ obj.nmsim }}</td>
                    <td class="col-width-char40">{{ obj.nmatividade }}</td>
                    <td class="col-width-char20">{{ obj.cpfcnpj }}</td>
                    <td class="col-width-char10">{{ obj.xstatus }}</td>
                    <td class="col-width-char15">{{ obj.nmstsisbi }}</td>
            </tr></tbody>
        </table></div>


        <div v-if="showPagination" class="pagination">
            <button :disabled="currentPage === 1" class="buttom-pagination--first" @click="currentPage=1; updatePaginatedData();" />
            <button :disabled="currentPage === 1" class="buttom-pagination--prior" @click="currentPage--; updatePaginatedData();" />
            <div class="field-label field-label-center">{{ currentPage }} de {{ Math.ceil(lsDadosMain.length / itemsPerPage) }}</div>
            <button :disabled="currentPage === Math.ceil(lsDadosMain.length / itemsPerPage)" class="buttom-pagination--next" @click="currentPage++; updatePaginatedData();" />
            <button :disabled="currentPage === Math.ceil(lsDadosMain.length / itemsPerPage)" class="buttom-pagination--last" @click="currentPage = Math.ceil(lsDadosMain.length / itemsPerPage); updatePaginatedData();" />
        </div>
    </div>
    

    <div v-if="modoEdicao">
        <EstabelecimentoEditPage :idEdicao="idEdicao" @close="modoEdicao = false" @save="lerDados" />
    </div>


    <div v-if="modoVisualizar">
        <EstabelecimentoViewPage :obj="selectedObj" @close="modoVisualizar = false" @save="lerDados"/>
    </div>
</template>


<script setup>
import { onMounted, ref } from 'vue';
import { genericPost } from '@/funcoes/api';
import { globalStore } from '@/globals';
import EstabelecimentoEditPage from '../formularios/EstabelecimentoEditPage.vue';
import EstabelecimentoViewPage from '../visualizacoes/EstabelecimentoViewPage.vue';
import SimSelect from '@/components/selects/SimSelect.vue';

const emit = defineEmits(['close']);
const idEdicao = ref(null);
const idSim = ref(null);
const isLoading = ref(false);
const lsDados = ref([]);
const modoEdicao = ref(false);
const modoEditarGestores = ref(false);
const modoVisualizar = ref(false);
const nmPesquisa = ref(null);
const msgAlerta = ref(null);
const ordenacao = ref('nome');
const selectedObj = ref(null);
const showSimSelect = ref(globalStore.ckperfilsupervisor);

const currentPage = ref(1);
const itemsPerPage = ref(globalStore.itensPorPagina);
const lsDadosMain = ref([]);
const showPagination = ref(false);


const aplicarOrdenacao = () => {
    const dados = [...lsDadosMain.value];

    if (ordenacao.value === 'nrosim') {
        dados.sort((a, b) => {
            const simA = Number(a.nrosim || 0);
            const simB = Number(b.nrosim || 0);

            if (simA !== simB) return simA - simB;

            return String(a.nmestabelecimento || '').localeCompare(
                String(b.nmestabelecimento || ''),
                'pt-BR'
            );
        });
    } else {
        dados.sort((a, b) => {
            return String(a.nmestabelecimento || '').localeCompare(
                String(b.nmestabelecimento || ''),
                'pt-BR'
            );
        });
    }

    lsDadosMain.value = dados;
    currentPage.value = 1;
    updatePaginatedData();
}


const closeForm = () => {emit('close');}

const lerDados = async() => {
    try{
        msgAlerta.value = null;
        isLoading.value = true;
        const req = await genericPost('/listas/estabelecimentos', {
            idep: globalStore.idep, 
            idsim: (showSimSelect.value) ? idSim.value : globalStore.idsim, 
            nmpesquisar: nmPesquisa.value});
        lsDadosMain.value = req;
        currentPage.value=1;
        showPagination.value = (lsDadosMain.value.length > itemsPerPage.value);
        aplicarOrdenacao();
    } catch (error){msgAlerta.value= error;
    } finally {isLoading.value = false;}
}

const novoCadastro = ()=>{
    idEdicao.value=0;
    modoEdicao.value=true;
}

const openView = (obj) =>{
    selectedObj.value=obj;
    modoVisualizar.value=true;
}

const updatePaginatedData = () => {
    const startIndex = (currentPage.value - 1) * itemsPerPage.value;
    const endIndex = (startIndex + itemsPerPage.value);
    lsDados.value = lsDadosMain.value.slice(startIndex, endIndex);
}

onMounted(lerDados);
</script>
